import { ICON_TYPES } from './iconTypes';

export default {
	search: {
		name: 'search',
		type: ICON_TYPES.ionicon,
		text: 'Search',
	},
	filter: {
		name: 'filter',
		type: ICON_TYPES.fontAwesome5,
		text: 'Filter',
	},
	filterOpen: {
		name: 'filterOpen',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Open Filter',
	},
	filterClose: {
		name: 'filterClose',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Close Filter',
	},
	filterRemove: {
		name: 'filterRemove',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Remove Filter',
	},
};